export interface Service {
  slug: string;
  icon: string; // lucide icon name
  titleDe: string;
  titleEn: string;
  shortDe: string;
  shortEn: string;
  priceFrom: number;
  // Long content used on detail page
  introDe: string;
  introEn: string;
  bullets: { de: string; en: string }[];
  faqs: { q: { de: string; en: string }; a: { de: string; en: string } }[];
}

export const services: Service[] = [
  {
    slug: "tueroeffnung-wien",
    icon: "DoorOpen",
    titleDe: "Türöffnung Wien",
    titleEn: "Door Opening Vienna",
    shortDe: "Schnelle, beschädigungsfreie Türöffnung in ganz Wien – 24h.",
    shortEn: "Fast, non-destructive door opening across Vienna – 24/7.",
    priceFrom: 79,
    introDe: "Tür zugefallen oder Schlüssel verloren? Unser Team in Wien öffnet Ihre Tür in der Regel in unter 5 Minuten – ohne Beschädigung des Schlosses. Wir arbeiten mit modernster Pick- und Schließtechnik und sind in 15–20 Minuten bei Ihnen.",
    introEn: "Locked out? Our Vienna technicians open most doors in under 5 minutes — without damaging the lock. We use modern picking and bypass tools and arrive in 15–20 minutes.",
    bullets: [
      { de: "In 15–20 Minuten vor Ort", en: "On-site in 15–20 minutes" },
      { de: "Beschädigungsfreie Öffnung in 95 % der Fälle", en: "Non-destructive opening in 95% of cases" },
      { de: "Festpreis ab 79 € – keine versteckten Kosten", en: "Fixed price from €79 – no hidden costs" },
      { de: "24/7 verfügbar – auch an Sonn- und Feiertagen", en: "Available 24/7 – including Sundays and holidays" },
    ],
    faqs: [
      { q: { de: "Was kostet eine Türöffnung in Wien?", en: "What does a door opening cost in Vienna?" }, a: { de: "Eine Standard-Türöffnung kostet ab 79 € werktags. Nachts, am Wochenende und an Feiertagen gelten Zuschläge. Sie erhalten den Festpreis vorab am Telefon.", en: "A standard door opening starts at €79 on weekdays. Surcharges apply at night, on weekends and holidays. You get the fixed price upfront by phone." } },
      { q: { de: "Wird das Schloss dabei beschädigt?", en: "Will the lock be damaged?" }, a: { de: "In den meisten Fällen nein. Unsere Techniker öffnen Türen mit speziellen Pick-Werkzeugen schadenfrei.", en: "In most cases no. Our technicians use special picking tools to open doors without damage." } },
      { q: { de: "Wie schnell sind Sie da?", en: "How fast do you arrive?" }, a: { de: "In den meisten Wiener Bezirken sind wir in 15–20 Minuten vor Ort.", en: "In most Vienna districts we arrive within 15–20 minutes." } },
    ],
  },
  {
    slug: "schluesseldienst-wien",
    icon: "KeyRound",
    titleDe: "Schlüsseldienst Wien",
    titleEn: "Locksmith Vienna",
    shortDe: "Ihr 24h Schlüsseldienst in Wien – fair, schnell und transparent.",
    shortEn: "Your 24/7 locksmith in Vienna – fair, fast and transparent.",
    priceFrom: 79,
    introDe: "Wir sind Ihr zuverlässiger Schlüsseldienst in Wien – 24 Stunden, 365 Tage im Jahr. Egal ob Türöffnung, Schlosswechsel oder Sicherheitsberatung: unsere Techniker sind in allen 23 Bezirken im Einsatz.",
    introEn: "We are your reliable locksmith in Vienna – 24 hours a day, 365 days a year. Whether door opening, lock change or security consultation – our technicians serve all 23 districts.",
    bullets: [
      { de: "Festpreis-Garantie", en: "Fixed-price guarantee" },
      { de: "Geprüfte und versicherte Techniker", en: "Certified and insured technicians" },
      { de: "Tag- und Nachtdienst", en: "Day and night service" },
      { de: "Service in allen 23 Wiener Bezirken", en: "Service in all 23 Vienna districts" },
    ],
    faqs: [
      { q: { de: "Sind Sie wirklich 24/7 erreichbar?", en: "Are you really available 24/7?" }, a: { de: "Ja, wir sind rund um die Uhr telefonisch erreichbar – auch nachts, sonntags und an Feiertagen.", en: "Yes, we are reachable by phone around the clock – also at night, Sundays and holidays." } },
      { q: { de: "Bekomme ich den Preis vorab?", en: "Do I get the price upfront?" }, a: { de: "Selbstverständlich. Sie erhalten am Telefon einen verbindlichen Festpreis – ohne Überraschungen.", en: "Of course. You receive a binding fixed price by phone – no surprises." } },
    ],
  },
  {
    slug: "schlosswechsel-wien",
    icon: "Lock",
    titleDe: "Schlosswechsel Wien",
    titleEn: "Lock Replacement Vienna",
    shortDe: "Schloss tauschen lassen – nach Einbruch, Umzug oder Schlüsselverlust.",
    shortEn: "Lock replacement – after burglary, move-in or lost key.",
    priceFrom: 99,
    introDe: "Nach einem Einbruch, Umzug oder Verlust des Schlüssels sollten Sie das Schloss umgehend tauschen lassen. Wir montieren hochwertige Sicherheitsschlösser europäischer Markenhersteller in ganz Wien.",
    introEn: "After a burglary, move-in or lost key, you should replace the lock immediately. We install high-quality security locks from European brands across Vienna.",
    bullets: [
      { de: "Markenschlösser EVVA, ABUS, KABA", en: "Brand locks EVVA, ABUS, KABA" },
      { de: "VdS-zertifizierte Sicherheit", en: "VdS-certified security" },
      { de: "Montage inklusive – ab 99 €", en: "Installation included – from €99" },
    ],
    faqs: [
      { q: { de: "Wann sollte ich mein Schloss wechseln?", en: "When should I replace my lock?" }, a: { de: "Nach Einbruch, Schlüsselverlust, Umzug oder bei abgenutztem Schloss.", en: "After burglary, lost key, move, or when the lock is worn." } },
    ],
  },
  {
    slug: "zylinder-wechseln-wien",
    icon: "Cylinder",
    titleDe: "Zylinder wechseln Wien",
    titleEn: "Cylinder Replacement Vienna",
    shortDe: "Profil-Zylinder schnell und günstig getauscht – ab 89 €.",
    shortEn: "Profile cylinder replaced quickly and affordably – from €89.",
    priceFrom: 89,
    introDe: "Der Zylinder ist das Herzstück Ihres Schlosses. Wir tauschen Ihren Zylinder gegen ein modernes Sicherheitsmodell mit Aufbohr-, Pick- und Ziehschutz.",
    introEn: "The cylinder is the heart of your lock. We replace your cylinder with a modern security model offering anti-drill, anti-pick and anti-pull protection.",
    bullets: [
      { de: "Schutzklasse bis zur höchsten Stufe", en: "Protection up to top class" },
      { de: "Sicherungskarte für Nachschlüssel", en: "Security card for spare keys" },
      { de: "Express-Service in ganz Wien", en: "Express service across Vienna" },
    ],
    faqs: [
      { q: { de: "Wie lange dauert ein Zylindertausch?", en: "How long does a cylinder change take?" }, a: { de: "In der Regel 10–20 Minuten.", en: "Usually 10–20 minutes." } },
    ],
  },
  {
    slug: "autooeffnung-wien",
    icon: "Car",
    titleDe: "Autoöffnung Wien",
    titleEn: "Car Opening Vienna",
    shortDe: "Auto aufgesperrt – ohne Schaden, in jedem Bezirk.",
    shortEn: "Car unlocked – without damage, in every district.",
    priceFrom: 89,
    introDe: "Schlüssel im Auto eingesperrt? Wir öffnen PKW aller Marken schadenfrei. Auch bei modernen Funkschlüsseln und Wegfahrsperren.",
    introEn: "Locked your keys in the car? We open all car brands without damage – including modern key fobs and immobilisers.",
    bullets: [
      { de: "Alle Marken & Modelle", en: "All brands & models" },
      { de: "Schadenfreie Öffnung", en: "Damage-free opening" },
      { de: "Mobil in ganz Wien", en: "Mobile in all of Vienna" },
    ],
    faqs: [
      { q: { de: "Können Sie auch Funkschlüssel öffnen?", en: "Can you open keyless cars?" }, a: { de: "Ja, wir verfügen über die nötige Technik für moderne Fahrzeuge.", en: "Yes, we have the necessary technology for modern vehicles." } },
    ],
  },
  {
    slug: "einbruchschutz-wien",
    icon: "ShieldCheck",
    titleDe: "Einbruchschutz Wien",
    titleEn: "Burglary Protection Vienna",
    shortDe: "Sicherheitsberatung & Nachrüstung – Türen, Fenster, Schlösser.",
    shortEn: "Security consulting & retrofit – doors, windows, locks.",
    priceFrom: 0,
    introDe: "Wir analysieren die Schwachstellen Ihres Zuhauses oder Geschäfts und installieren Sicherheitsbeschläge, Querriegel, Panzerriegel und Alarmsysteme nach österreichischer Norm.",
    introEn: "We analyse the weak points of your home or business and install security fittings, cross-bars, anti-bar locks and alarm systems according to Austrian standards.",
    bullets: [
      { de: "Kostenlose Erstberatung", en: "Free initial consultation" },
      { de: "Förderfähige Maßnahmen", en: "Subsidy-eligible measures" },
      { de: "Polizeilich empfohlene Technik", en: "Police-recommended technology" },
    ],
    faqs: [
      { q: { de: "Wird Einbruchschutz gefördert?", en: "Is burglary protection subsidised?" }, a: { de: "Ja – das Land Wien fördert mechanische Sicherheitsmaßnahmen.", en: "Yes – the City of Vienna subsidises mechanical security measures." } },
    ],
  },
  {
    slug: "notdienst-24h-wien",
    icon: "Clock",
    titleDe: "Notdienst 24h Wien",
    titleEn: "24h Emergency Service Vienna",
    shortDe: "Rund um die Uhr – auch nachts, sonntags und an Feiertagen.",
    shortEn: "Around the clock – also nights, Sundays and holidays.",
    priceFrom: 79,
    introDe: "Unser Notdienst ist 24 Stunden, 7 Tage die Woche für Sie im Einsatz. Wir kommen schnell, arbeiten sauber und nennen Ihnen den Festpreis vor Anfahrt.",
    introEn: "Our emergency service is on call 24 hours, 7 days a week. We arrive fast, work clean and tell you the fixed price before dispatch.",
    bullets: [
      { de: "24/7/365 verfügbar", en: "Available 24/7/365" },
      { de: "Festpreis am Telefon", en: "Fixed price by phone" },
      { de: "Schnelle Anfahrt in ganz Wien", en: "Fast arrival across Vienna" },
    ],
    faqs: [
      { q: { de: "Gibt es Nachtzuschläge?", en: "Are there night surcharges?" }, a: { de: "Ja, nachts und an Feiertagen gelten gesetzliche Zuschläge – diese werden vorab transparent kommuniziert.", en: "Yes, statutory surcharges apply at night and on holidays – communicated transparently in advance." } },
    ],
  },
  {
    slug: "tresoroeffnung-wien",
    icon: "Vault",
    titleDe: "Tresoröffnung Wien",
    titleEn: "Safe Opening Vienna",
    shortDe: "Tresore aller Marken öffnen – diskret, schadenfrei.",
    shortEn: "Safes of all brands opened – discreet, damage-free.",
    priceFrom: 149,
    introDe: "Code vergessen oder Schlüssel verloren? Wir öffnen Tresore aller Marken und Sicherheitsstufen – auf Wunsch ohne sichtbare Beschädigung.",
    introEn: "Forgot the code or lost the key? We open safes of all brands and security levels – non-destructively on request.",
    bullets: [
      { de: "Diskretion garantiert", en: "Discretion guaranteed" },
      { de: "Wertsachen bleiben unversehrt", en: "Valuables remain untouched" },
      { de: "Auch Bürotresore und Wandsafes", en: "Including office and wall safes" },
    ],
    faqs: [
      { q: { de: "Brauche ich einen Eigentumsnachweis?", en: "Do I need proof of ownership?" }, a: { de: "Ja, aus rechtlichen Gründen benötigen wir einen Identitäts- und Eigentumsnachweis.", en: "Yes, for legal reasons we require ID and proof of ownership." } },
    ],
  },
];

export const getService = (slug: string) => services.find((s) => s.slug === slug);